import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {heavyHitters_template} from "../components/templates/heavyHitters_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class heavyHitters extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected heavyHitters_template: heavyHitters_template;

    protected getModuleName(){

        return "heavyHitters";
    }

    buildContent() : Array<Element>{

        this.heavyHitters_template = new heavyHitters_template( "heavyHitters", this.viewModel, this );
        this.template = this.heavyHitters_template;

        return [this.heavyHitters_template.build()];
    }

    public fillPage() : void{

        this.heavyHitters_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/heavyHitters/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });
        };
    }

    protected updateFilters(responseParsed: any){

        this.heavyHitters_template.setBrandFilterItems(responseParsed.departments);
        this.heavyHitters_template.setBrandSegments(responseParsed.brandSegments);
        this.heavyHitters_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.heavyHitters_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.heavyHitters_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.heavyHitters_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.heavyHitters_template.setPostPaymentCategorySystemFilterItems(responseParsed.postPaymentCategorySystems);

        this.heavyHitters_template.setSelectedPostInitiative(responseParsed.selectedPostInitiative);
        this.heavyHitters_template.setArticleTypesFilterItems();
        this.heavyHitters_template.setPostContentTypesGroupFilterItems();
    }

    public getListData(): void{

        this.heavyHitters_template.getTemplateViewModel().isDataLoading(1);
        let subViewModel = this.heavyHitters_template.getViewModelForRequest();
        let baseApiUrl = '/api/heavyHitters/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    protected filterDateOnChange(){

        this.getListData();
    }

    protected filterSimpleOnChange(){

        this.getListData();
    }

    public filterDropdownOnChange(){

        this.getListData();
    }


    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateGraph(responseParsed);
            });
            obj.heavyHitters_template.getTemplateViewModel().isDataLoading(0);
        };
    }

    protected updateGraph(responseParsedData: any) {

        this.heavyHitters_template.setGraphLinesInfo(responseParsedData.graphLinesInfo);
        this.heavyHitters_template.updateGraphData(responseParsedData.data);

    }

    protected getAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url: string = '';
        let usrReq_callback;
        switch (id){

            case 'primaryTagFilter':{

                usrReq_url = '/api/emakiBasicTagSuggestions/';
                usrReq_callback = this.onGetAutoCompletePrimaryTagsSuggestionsReturn;
                break;
            }
            case 'tagsFilter':{

                usrReq_url = '/api/emakiBasicTagSuggestions/';
                usrReq_callback = this.onGetAutoCompleteTagsSuggestionsReturn;
                break;
            }

            case 'tagTypesFilter':{

                usrReq_url = '/api/emakiBasicTagTypeSuggestions/';
                usrReq_callback = this.onGetAutoCompleteTagTypesSuggestionsReturn;
                break;
            }

            case 'primaryCategoriesFilter':{

                usrReq_url = '/api/emakiCategorySuggestions/';
                usrReq_callback = this.onGetAutoCompleteCategoriesSuggestionsReturn;
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetAutoCompletePrimaryTagsSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.heavyHitters_template.setPrimaryTagFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetAutoCompleteTagsSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.heavyHitters_template.setTagsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetAutoCompleteTagTypesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.heavyHitters_template.setTagTypesFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetAutoCompleteCategoriesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.heavyHitters_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url = '/api/emakiUsers/get/';
        let usrReq_callback;
        switch (id){

            case 'srEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteSrEditorsSuggestionsReturn;
                break;
            }

            case 'jrEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteJrEditorsSuggestionsReturn;
                break;
            }

            case 'authorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteAuthorSuggestionsReturn;
                break;
            }

            case 'ideatorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteIdeatorSuggestionsReturn;
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    obj.heavyHitters_template.setSrEditorsFilterItems(responseParsed.data);
                }
            });
        };

    }

    protected onGetMultipleAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.heavyHitters_template.setJrEditorsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetMultipleAutoCompleteAuthorSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    obj.heavyHitters_template.setAuthorsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetMultipleAutoCompleteIdeatorSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    obj.heavyHitters_template.setIdeatorsFilterItems(responseParsed.data);
                }
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/heavyHitters.ts